var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('top-nav', {
    ref: "topNav",
    attrs: {
      "scale": _vm.currentScale
    }
  }), _c('div', {
    ref: "scaleContainer",
    staticClass: "scale-container"
  }, [_c('div', [_c('experience-view'), _c('monetization-view'), _c('platform-view'), _c('all-platform-view', {
    attrs: {
      "scale": _vm.currentScale
    }
  }), _c('scene-view'), _c('swiper-view'), _c('partner'), _c('contact-view')], 1), _c('footer')])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };